;(() => {
  if (window.__smCheckout) return
  window.__smCheckout = true

  function giftSelections(cart) {
    const selections = {}
    for (const item of cart.items) {
      const props = item.properties || {}
      if (props._sm_offer && props._sm_gift)
        selections[String(props._sm_offer).split(':')[0]] = String(props._sm_gift)
    }
    return selections
  }

  function lineProperties(item) {
    const entries = Object.entries(item.properties || {}).filter(
      ([, value]) => typeof value === 'string' && value,
    )
    return entries.length ? Object.fromEntries(entries.slice(0, 20)) : undefined
  }

  if (new URLSearchParams(window.location.search).get('sm_cart') === 'clear') {
    fetch('/cart/clear.js', { method: 'POST', headers: { accept: 'application/json' } }).catch(
      () => null,
    )
  }

  function cookie(name) {
    try {
      const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
      return match ? decodeURIComponent(match[1]) : undefined
    } catch {
      return undefined
    }
  }

  function fnv1a(text) {
    let hash = 0x811c9dc5
    for (let i = 0; i < text.length; i++) {
      hash ^= text.charCodeAt(i)
      hash = Math.imul(hash, 0x01000193) >>> 0
    }
    return hash >>> 0
  }

  function assignVariant(experimentId, visitor, variants) {
    const total = variants.reduce((n, v) => n + v.weight, 0)
    if (total <= 0) return null
    let bucket = fnv1a(`${experimentId}:${visitor}`) % total
    for (const variant of variants) {
      if (bucket < variant.weight) return variant
      bucket -= variant.weight
    }
    return null
  }

  function visitorId() {
    const current = cookie('_sm_vid')
    if (current && /^[A-Za-z0-9_-]{8,64}$/.test(current)) return current
    const id =
      window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID().replace(/-/g, '')
        : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`
    document.cookie = `_sm_vid=${id}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`
    return id
  }

  function excludedVisitor() {
    return Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      navigator.webdriver ||
      /bot|crawl|spider|slurp|headless|lighthouse|preview/i.test(navigator.userAgent),
    )
  }

  function forcedVariant(experimentId) {
    try {
      const param = new URLSearchParams(window.location.search).get('sm_ab')
      if (param) sessionStorage.setItem('sm_ab', param)
      const [test, variant] = (param || sessionStorage.getItem('sm_ab') || '').split(':')
      return test === experimentId && variant ? variant : null
    } catch {
      return null
    }
  }

  function experimentsConfig() {
    const node = document.querySelector('script[data-sm-experiments]')
    if (!node) return null
    try {
      const config = JSON.parse(node.textContent || 'null')
      return config && Array.isArray(config.tests) && config.tests.length
        ? { ...config, shop: node.dataset.shop }
        : null
    } catch {
      return null
    }
  }

  function assignmentFor(config, type) {
    const test = config && config.tests.find((t) => t.type === type)
    if (!test) return null
    const forced = forcedVariant(test.id)
    const skip = excludedVisitor()
    const visitor = visitorId()
    const variant = forced
      ? test.variants.find((v) => v.id === forced)
      : skip
        ? test.variants[0]
        : assignVariant(test.id, visitor, test.variants)
    return variant ? { test, variant, visitor, counted: !forced && !skip } : null
  }

  const exposed = new Set()
  function expose(config, assignments) {
    const ids = assignments
      .filter((a) => a && a.counted && !exposed.has(a.test.id))
      .map((a) => a.test.id)
    if (!config || !config.eventsUrl || !config.shop || !ids.length) return
    ids.forEach((id) => exposed.add(id))
    try {
      nativeFetchRef(config.eventsUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ shop: config.shop, visitorId: visitorId(), experimentIds: ids }),
        keepalive: true,
      }).catch(() => null)
    } catch {

    }
  }
  const nativeFetchRef = window.fetch.bind(window)

  async function prepareShopifyCart(config, shipping) {
    const code = shipping && shipping.variant.code
    try {
      const cart = await (
        await nativeFetchRef('/cart.js', { headers: { accept: 'application/json' } })
      ).json()
      const codes = (cart.discount_codes || []).map((d) => d.code)
      const body = { attributes: { _sm_vid: visitorId() } }
      if (code && !codes.some((c) => c.toLowerCase() === code.toLowerCase()))
        body.discount = [...codes, code].join(',')
      if (cart.attributes && cart.attributes._sm_vid === body.attributes._sm_vid && !body.discount)
        return
      await nativeFetchRef('/cart/update.js', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify(body),
      })
    } catch {

    }
  }

  const abConfig = experimentsConfig()
  if (abConfig) expose(abConfig, [assignmentFor(abConfig, 'shipping')])

  try {
    const params = new URLSearchParams(window.location.search)
    for (const name of ['fbclid', 'ttclid']) {
      const value = params.get(name)
      if (value)
        document.cookie = `_sm_${name}=${encodeURIComponent(`${Date.now()}.${value}`)}; path=/; max-age=${60 * 60 * 24 * 7}; SameSite=Lax`
    }
  } catch {

  }

  function customerPrivacy() {
    return new Promise((resolve) => {
      const shopify = window.Shopify
      if (shopify && shopify.customerPrivacy) return resolve(shopify.customerPrivacy)
      if (!shopify || typeof shopify.loadFeatures !== 'function') return resolve(null)
      const timer = setTimeout(() => resolve(null), 1500)
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        clearTimeout(timer)
        resolve(error ? null : window.Shopify.customerPrivacy || null)
      })
    })
  }

  async function attribution() {
    try {
      const privacy = await customerPrivacy()
      const allowed = (fn) => Boolean(privacy && typeof privacy[fn] === 'function' && privacy[fn]())
      const ga = cookie('_ga')
      const gaClientId = ga ? ga.split('.').slice(-2).join('.') : undefined
      const clicked = (name) => {
        const value = cookie(`_sm_${name}`)
        if (!value) return { at: undefined, id: undefined }
        const dot = value.indexOf('.')
        return { at: value.slice(0, dot), id: value.slice(dot + 1) }
      }
      const fbclid = clicked('fbclid')
      return {
        fbp: cookie('_fbp'),
        fbc:
          cookie('_fbc') ||
          (fbclid.id ? `fb.1.${fbclid.at}.${fbclid.id}`.slice(0, 300) : undefined),
        ttp: cookie('_ttp'),
        ttclid: clicked('ttclid').id?.slice(0, 300),
        gaClientId: gaClientId && /^\d+\.\d+$/.test(gaClientId) ? gaClientId : undefined,
        sourceUrl: `${window.location.origin}${window.location.pathname}`,
        consent: {
          analytics: allowed('analyticsProcessingAllowed'),

          marketing:
            allowed('marketingAllowed') &&
            (!privacy ||
              typeof privacy.saleOfDataAllowed !== 'function' ||
              privacy.saleOfDataAllowed()),
        },
      }
    } catch {
      return undefined
    }
  }

  function isPurchase(item) {
    return !(item.properties && item.properties._sm_gift_for)
  }

  let cleaning = false
  async function removeUnearnedGifts(rules) {
    if (cleaning) return
    cleaning = true
    try {
      const cart = await fetch('/cart.js', { headers: { accept: 'application/json' } }).then((r) =>
        r.json(),
      )
      const items = cart.items || []
      const now = Date.now()
      const live = (rule) =>
        (!rule.startsAt || Date.parse(rule.startsAt) <= now) &&
        (!rule.endsAt || Date.parse(rule.endsAt) > now)
      const giftIds = new Set(rules.flatMap((r) => (r.variantIds || []).map(String)))
      const bought = (productIds) =>
        items
          .filter(
            (item) =>
              !giftIds.has(String(item.variant_id)) && productIds.includes(String(item.product_id)),
          )
          .reduce((n, item) => n + item.quantity, 0)

      const target = new Map(items.map((item) => [item.key, item.quantity]))
      for (const rule of rules) {
        const ids = (rule.variantIds || []).map(String)
        let allowed =
          live(rule) && bought((rule.productIds || []).map(String)) >= rule.minQuantity
            ? rule.quantity
            : 0
        for (const item of items) {
          if (!ids.includes(String(item.variant_id))) continue
          const keep = Math.min(item.quantity, allowed)
          allowed -= keep
          target.set(item.key, keep)
        }
      }

      for (const item of items) {
        if (
          !isPurchase(item) &&
          !giftIds.has(String(item.variant_id)) &&
          item.final_line_price === 0
        )
          target.set(item.key, 0)
      }
      const changes = items
        .filter((item) => target.get(item.key) !== item.quantity)
        .map((item) => [item.key, target.get(item.key)])
      if (!changes.length) return
      let data = null
      for (const [key, quantity] of changes) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity,
            sections: ['cart-drawer', 'cart-icon-bubble'],
          }),
        })
        data = await res.json().catch(() => null)
      }
      const drawer = document.querySelector('cart-drawer')
      if (drawer && typeof drawer.renderContents === 'function' && data) drawer.renderContents(data)
      else if (window.location.pathname.endsWith('/cart')) window.location.reload()
    } catch {

    } finally {
      cleaning = false
    }
  }

  let giftRules = []

  if (!customElements.get('sm-cart-gifts')) {
    customElements.define(
      'sm-cart-gifts',
      class extends HTMLElement {
        connectedCallback() {
          try {
            giftRules = JSON.parse(this.dataset.rules || '{}').rules || []
          } catch {
            giftRules = []
          }
          if (giftRules.length && this.dataset.count !== '0') removeUnearnedGifts(giftRules)
        }
      },
    )
  }

  const CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?$/
  let pending = null
  const nativeFetch = window.fetch
  window.fetch = function (...args) {
    const response = nativeFetch.apply(this, args)
    try {
      const input = args[0]
      const url = new URL(
        typeof input === 'string' || input instanceof URL ? String(input) : input.url,
        window.location.origin,
      )
      if (giftRules.length && !cleaning && CART_CHANGE.test(url.pathname))
        response
          .then(() => {
            clearTimeout(pending)
            pending = setTimeout(() => removeUnearnedGifts(giftRules), 300)
          })
          .catch(() => null)
    } catch {

    }
    return response
  }

  document.addEventListener(
    'click',
    async (event) => {
      const button =
        event.target instanceof Element ? event.target.closest('[name="checkout"]') : null
      if (!button || button.dataset.smBypass) return
      const config = document.querySelector('sm-checkout[data-checkout-url]')

      const checkoutTest = assignmentFor(abConfig, 'checkout')
      const shippingTest = assignmentFor(abConfig, 'shipping')
      expose(abConfig, [checkoutTest, shippingTest])
      const currencies = config
        ? (config.dataset.currencies || config.dataset.shopCurrency || '').split(',')
        : []

      let previewing = false
      try {
        previewing = Boolean(sessionStorage.getItem('sm_ab'))
      } catch {
        previewing = false
      }

      const themes = config?.dataset.themeIds
      const themeId = String(window.Shopify?.theme?.id ?? '')
      const onTheme = themes === undefined || themes.split(',').includes(themeId)
      const ours =
        config &&
        onTheme &&
        !previewing &&
        currencies.includes(config.dataset.currency) &&
        (!checkoutTest || checkoutTest.variant.checkout !== 'shopify')

      const toShopify = async () => {
        if (abConfig) await prepareShopifyCart(abConfig, shippingTest)
        button.removeAttribute('aria-busy')
        button.dataset.smBypass = '1'
        button.click()
      }
      if (!ours) {
        if (!abConfig) return
        event.preventDefault()
        event.stopImmediatePropagation()
        button.setAttribute('aria-busy', 'true')
        await toShopify()
        return
      }
      event.preventDefault()
      event.stopImmediatePropagation()
      button.setAttribute('aria-busy', 'true')
      try {
        const cart = await (
          await fetch('/cart.js', { headers: { accept: 'application/json' } })
        ).json()

        if (cart.items.some((item) => item.selling_plan_allocation)) throw new Error('abonnement')

        const titles = new Set()
        for (const application of cart.cart_level_discount_applications || [])
          if (application.type !== 'discount_code') titles.add(application.title)
        for (const item of cart.items)
          for (const allocation of item.line_level_discount_allocations || [])
            if (
              allocation.discount_application &&
              allocation.discount_application.type !== 'discount_code'
            )
              titles.add(allocation.discount_application.title)
        const res = await fetch(config.dataset.checkoutUrl, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            shop: config.dataset.shop,
            locale: (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase(),
            currency: config.dataset.currency,
            country: config.dataset.country || undefined,

            root: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
            lines: cart.items.filter(isPurchase).map((item) => ({
              variantId: String(item.variant_id),
              quantity: item.quantity,
              properties: lineProperties(item),
            })),
            giftSelections: giftSelections(cart),
            attribution: await attribution(),
            visitorId: cookie('_sm_vid') || (abConfig ? visitorId() : undefined),
            discounts: {
              codes: (cart.discount_codes || []).map((d) => d.code),
              titles: [...titles],
            },
          }),
        })
        const body = res.ok ? await res.json() : null
        if (!body || !body.data || !body.data.url) throw new Error('checkout indisponible')
        window.location.href = body.data.url
      } catch {
        await toShopify()
      }
    },
    true,
  )
})()
